import { useIsFeatureEnabled } from '@shared/core/featureFlags';

// Hoisted so every consumer passes the same options object identity to the hook.
const PRICE_ALERTS_FLAG_OPTIONS = { consentKey: 'accommodationsPriceAlerts' } as const;

/**
 * The single gate for every price-alerts surface (the accommodations banner, the two Guest Guide
 * actions, and the reminder-modal trigger).
 *
 * `accommodationsPriceAlerts` is both an Amplitude experiment and a `UserConsentKey` of the same
 * name, so one `useIsFeatureEnabled` call resolves both: the per-event consent override wins when
 * set (`true` → treatment, `false` → control) and otherwise the Amplitude assignment decides.
 *
 * This is a straight on/off gate with no day-range logic: treatment shows every surface at all
 * horizons, control hides every surface at all horizons.
 *
 * Returns `false` while remote flags are still loading, so no surface flashes in before the
 * per-event override is known.
 */
export const usePriceAlertsActive = (): boolean => {
  const [isEnabled] = useIsFeatureEnabled('accommodationsPriceAlerts', PRICE_ALERTS_FLAG_OPTIONS);

  return isEnabled;
};
